import { Link } from "react-router-dom";
import React, { useState } from "react";

import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";

import { all_routes } from "../router/all_routes";
import { BookingSteps } from "../../core/data/redux/actions/commonActions";

const PaymentPending = () => {
  const routes = all_routes;

  const [step] = useState(5);

  return (
    <div>
      {
        <div className="booking-new-module">
          <div className="container">
            <div className="booking-wizard-head mb-0">
              <div className="row align-items-center">
                <div className="col-xl-4 col-lg-3">
                  <div className="booking-head-title d-none d-md-block">
                    <h4>Reserve Your Car</h4>
                  </div>
                </div>
                <div className="col-xl-8 col-lg-9 justify-content-left display-grid">
                  <Box className="px-0 " sx={{ width: "100%" }}>
                    <Stepper
                      activeStep={step}
                      alternativeLabel
                      sx={{
                        ".MuiStep-root": { width: "5rem" },
                        ".MuiStepIcon-root.Mui-completed": { color: "#009FDF" },
                        ".MuiStepIcon-root.Mui-active": { color: "#009FDF" },
                        ".MuiStepLabel-label": {
                          fontFamily: "GT Walsheim Trial Rg",
                        },
                      }}
                    >
                      {BookingSteps?.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                </div>
              </div>
            </div>
            <div className="booking-card my-5">
              <div className="success-book">
                <span className="success-icon">
                  <i className="fa-solid fa-check-double" />
                </span>
                <h6 className="fw-bold">
                  Your payout details have been saved successfully. Our team
                  will contact you soon to complete the payment.
                </h6>
              </div>

              <div className="m-4 text-center">
                <button
                  type="button"
                  className="text-white bg-primary mt-2 p-2 px-5 border-0"
                  style={{ cursor: "pointer" }}
                >
                  <Link to={routes.homeOne} className="text-white">
                    Home
                  </Link>{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default PaymentPending;
